var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4033 -14489)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(4033 14489)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2750.691 14836.168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1311.208-334.528c.7-.679,1.371-1.38,2.035-2.091a.915.915,0,0,0,.037-1.441.934.934,0,0,0-1.4.063c-.447.425-.873.872-1.309,1.308-.977.977-.977.976-2.028.154-.056-.044-.114-.086-.171-.129a13.118,13.118,0,0,0-6.455-2.582c-.476-.06-.619-.245-.6-.718.038-1,.033-1.994,0-2.99-.016-.489.129-.672.639-.659,1.186.031,2.374,0,3.561.011a.814.814,0,0,0,.888-.818.881.881,0,0,0-.71-1.068,3.179,3.179,0,0,0-.706-.053q-2.315-.006-4.629,0c-1.685,0-3.371-.012-5.056.007-.745.009-1.116.391-1.09,1.023s.359.9,1.093.908c1.068,0,2.138.042,3.2-.013.686-.035.873.222.824.86-.047.614-.01,1.234-.01,1.851,0,1.555,0,1.54-1.507,1.813a12.523,12.523,0,0,0-7.083,3.794,13.257,13.257,0,0,0-.283,18.138,13.414,13.414,0,0,0,17.343,2.111,13.3,13.3,0,0,0,3.338-18.719A.48.48,0,0,1,1311.208-334.528Zm-10.885,19.741a11.327,11.327,0,0,1-11.33-11.295,11.253,11.253,0,0,1,11.319-11.288,11.133,11.133,0,0,1,11.289,11.263A11.272,11.272,0,0,1,1300.322-314.787Z",
    transform: "translate(0 0)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.465-260.583c0-1.471-.005-2.943,0-4.414,0-.761.328-1.15.939-1.171.652-.023,1.052.373,1.055,1.149q.022,4.45,0,8.9c0,.759-.4,1.134-1.073,1.114-.635-.019-.919-.365-.922-1.163C1373.461-257.64,1373.465-259.112,1373.465-260.583Z",
    transform: "translate(-74.139 -68.066)",
    fill: "#58beb3",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.5bf5bb39.svg";
export { ForwardRef as ReactComponent };